var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0L18.3333 3.66667V15.5833C18.3333 16.0896 17.9229 16.5 17.4167 16.5H0.916667C0.41041 16.5 0 16.0896 0 15.5833V3.6699L1.83333 0H16.5ZM16.5 5.5H1.83333V14.6667H16.5V5.5ZM10.0833 6.41667V10.0833H12.8333L9.16667 13.75L5.5 10.0833H8.25V6.41667H10.0833ZM15.3669 1.83333H2.96685L2.05099 3.66667H16.2836L15.3669 1.83333Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/ArchiveIcon.0400a6bfff14aac40a5e71930a61f4b8.svg";
export { ForwardRef as ReactComponent };